/*!
 * Table of contents
 * 01. Global Modules
 * 02. Account Modules
 * 03. Carousel Modules
 * 04. Checkout Modules - shopping bag
 * 05. Checkout Modules - chckout path
 * 06. Contact Us Modules
 * 07. Modal Modules
 * 08. Product Display Modules
 * 09. Product Listing Modules
 * 10. Account Modules
 * 11. Product Recs Modules
 * 12. Device Specific Modules
 */

//
// 01. Global Modules
// -----------------------------------------------------------------------------
window.Promise = window.Promise || require('es6-promise').Promise;

import { matchElementHeight } from '../../modules/global/_matchElementHeight';
import {
	setCookieOrWebStorage,
	getCookieOrWebStorage,
	setExpiringCookieOrWebStorage,
	checkCookie,
	getCookie,
	setCookies,
	setExpiringCookies,
	getNumberFromCookie as _getNumberFromCookie,
	removeCookieOrWebStorage,
	expireObsoleteCookies,
	setAkamaiWait,
} from '../../modules/global/_cookies';
import { checkForSpecialCharactersInUrl } from '../../modules/global/_replaceSpecialCharactersInUrl.js';
import { checkForResultListForContentRecWidget } from '../../modules/global/_checkForResultListForContentRecWidget';

import * as everythingScrolls from '../../modules/global/_scroll';
import { showBackToRegistryLink } from '../../modules/global/_showBackToRegistryLink';
import { callAjaxEspots } from '../../modules/global/_callAjaxEspots';
import { buttonGroupActiveFix } from '../../modules/global/_buttonGroupActiveFix';
import { breadCrumbs } from '../../modules/global/_breadcrumbs';

//import { slickStatic } from '../../modules/carousel/_slick';

import { formValidation, Validate } from '../../modules/global/_formValidation';
import { inlineFormValidationOnBlur } from '../../modules/global/_inlineFormValidationOnBlur';
import { stripRestrictedCharFromInput } from '../../modules/global/_stripRestrictedCharFromInput';
import { sanitizeInputAgainstXSS } from '../../modules/global/_sanitizeInputAgainstXSS.js';
import { toggleShopBrands } from '../../modules/global/_toggleShopBrands';
import { captchaWhatsThisToggle } from '../../modules/global/_captchaWhatsThisToggle';
import { getPageViewData as _getPageViewData } from '../../modules/modal/_getPageViewData';
import { selectScroller } from '../../modules/global/_selectScroller';
import { getUrlVars, getUrlVar } from '../../modules/global/_getUrlVars';
import { submitForm as submitFormKeyCodes } from '../../modules/global/_submitForm';
import { preventDoubleClick } from '../../modules/global/_doubleClick';
import { wlSetGridState } from '../../modules/global/_wlSetGridState';

import { desktopTabletLoadAdaptiveImg } from '../../modules/global/_loadAdaptiveImg';
import { triggerUpdateWriteReviewFields } from '../../modules/global/_triggerUpdateWriteReviewFields';
import { viewProductPersonalizationTracking, orderCompletePersonalizationTracking, selectOnChangePersonalization, savePersonalizationPointsToDatabase, personalizationInit } from '../../modules/global/_personalization';
import { myFavoritesInit } from '../../modules/global/_myFavoritesPersonalization';
import { compareCaptchaLogin } from '../../modules/account/_compareCaptchaLogin';
import { swapMyDillardsButtons } from '../../modules/global/_swapMyDillardsButtons';
import { ajaxShareProduct as _ajaxShareProduct } from '../../modules/modal/_ajaxShareProduct';

import { customCheckBox } from '../../modules/global/_customCheckBox';
import { addPageClass } from '../../modules/global/_addPageClass';
import { submitEmailSignupForm, ajaxEmailSignup } from '../../modules/modal/_ajaxEmailSignup';
import { submitTextSignupForm, ajaxTextSignup } from '../../modules/modal/_ajaxTextSignup';
import { retrieveIntlCacheCallVariable } from '../../modules/international/_intl';
import { removeOldDotDillardsCookies } from '../../modules/global/_removeOldDotDillardsCookies';
import { promptEmailOptInModal } from '../../modules/global/_promptEmailOptInModal';
import { cvvSecurityCodeToggle } from '../../modules/global/_cvvSecurityCodeToggle';
import { valToLowercase } from '../../modules/global/_valToLowercase';
import { qtyEnter } from '../../modules/global/_qtyEnter';
import { setAuthHeaders } from '../../modules/global/_authHeaders';

import { getURLParamValue } from '../../modules/global/_getURLParamValue';
import { passwordFailTip } from '../../modules/global/_passwordFailTip';
import { adaEventBinds } from '../../modules/global/_adaEventBinds';

import { qtyButtons } from '../../modules/global/_qtyButtons';

import { permTippyTop } from '../../modules/global/_permTippyTop';

//
// 02. Account Modules
// ---------------------------------------------------------
import { wishlist } from '../../modules/account/_wishlist';
import { memberClickBind } from '../../modules/account/_memberClickBind';
import { loginInputFocus } from '../../modules/account/_loginInputFocus';
import { showPassword, confirmShowPassword, personalInfoPagePassword } from '../../modules/account/_showPassword';

//
// 03. Carousel Modules
// -----------------------------------------------------------------------------
import { allDevicesResetAltImgContainer } from '../../modules/carousel/_resetAltImgContainer';
import { desktopTabletVerticalRecs } from '../../modules/carousel/_verticalRecs';
import { carouselResize } from '../../modules/carousel/_carouselResize';
import * as eGiftcardFunctions from '../../modules/carousel/_eGiftcard';

//
// 04. Checkout Modules - shopping bag
// -----------------------------------------------------------------------------
//
import { allDevicesChanelOverMaxReached } from '../../modules/checkout/_chanelOverMaxReached';
import { allDevicesDeclineGift } from '../../modules/checkout/_declineGift';
import { allDevicesIsInternationalRegistry } from '../../modules/checkout/_isInternationalRegistry';
import { orderCompleteCreateAccount } from '../../modules/checkout/_orderCompleteCreateAccount';
import { allDevicesPressEnterToEstTax, allDevicesToggleEstTax, estimateShippingAndTax } from '../../modules/checkout/_estimateTax';
import { skipGift } from '../../modules/checkout/_skipGift';
import { submitModalCart } from '../../modules/checkout/_submitModalCart';
import { itsatrapmodal } from '../../modules/checkout/_trap-user-modal';
import { estTaxPopup } from '../../modules/checkout/_estTaxPopup';
import { updateRewardCodeCount } from '../../modules/checkout/_updateRewardCodeCount';
import { updateQty } from '../../modules/checkout/_updateQty';
import { setupPaypalPaymentPage, setupPaypalExpressCheckout } from '../../modules/checkout/_paypal';
import { setupAfterpay } from '../../modules/checkout/_afterpay';
import { promoRewardModalBinds } from '../../modules/checkout/_promotionReward';
import { getCardBrand2 } from '../../modules/checkout/_getCardBrand2';
import { callRecs } from '../../modules/checkout/_recommendations';
import { createOptiUser, getFeatureFlagVariation } from '../../modules/global/_featureFlagSetup';
import { getDdsUUID } from '../../modules/global/_getDdsUUID.js';
import { setupApplePayCartPage } from '../../modules/checkout/_applepay';

// import {
//     closeNextDay
// } from '../../modules/checkout/_nextDayModal';
//
// 05. Checkout Modules - checkout path
//-----------------------------------------------------------------------------
//
import { allDevicesCheckRegisterCheckbox } from '../../modules/checkout/_checkRegisterCheckbox';
import { allDevicesClearPasswordField } from '../../modules/checkout/_clearPasswordField';
import { desktopTabletChangePanelUI } from '../../modules/checkout/_changePanelUI';
import { allDevicesSetupCheckoutPages } from '../../modules/checkout/_checkoutPages';
//
// 06. Contact Us Modules
// -----------------------------------------------------------------------------
import { populateStates, storeCityChange } from '../../modules/contactUs/_cityState';
import { dropdownChanges, documentSet, submitForm } from '../../modules/contactUs/_contact';

//
// 07. Modal Modules
// -----------------------------------------------------------------------------
import { dillardsModal } from '../../modules/modal/_dillardsModal';

//
// 08. Product Display Modules
// -----------------------------------------------------------------------------
import { allDevicesAltImageClickSetup, allDevicesProductImage, tap2zoom, tap2zoom_shoppingbag, tap2zoom_wl } from '../../modules/productDisplay/_images';
import { allDevicesCaptureCachedState } from '../../modules/productDisplay/_captureCachedState';
import { checkShipInternational, allDevicesCheckShipInternationalOnLoad } from '../../modules/productDisplay/_checkShipInternational';
import { allDevicesColorRegistryButton, allDevicesBindEventTypeToRURL } from '../../modules/productDisplay/_registry';
import { getCYL } from '../../modules/productDisplay/_CYL';
import { initCollections } from '../../modules/productDisplay/_shopCollections';
import { allDevicesProductPageSetup } from '../../modules/productDisplay/_productPageSetup';
import { allDevicesWanelo } from '../../modules/productDisplay/_wanelo';
import { zoomMainImageD } from '../../modules/productDisplay/_zoom';
import { inventoryOnHandEmail } from '../../modules/productDisplay/_email';
import { powerReviews_all, powerReviews_dt } from '../../modules/productDisplay/_powerReviews';
import { wishListResponse } from '../../modules/productDisplay/_wishListResponse';
import { fixedOutfitImg } from '../../modules/productDisplay/_fixedOutfitImg';
import { fixedOutfitImgScroll } from '../../modules/productDisplay/_fixedOutfitImg';
import { scrollToATWLAlert } from '../../modules/productDisplay/_scrollToATWLAlert';

//
// 09. Product Listing Modules
// -----------------------------------------------------------------------------
import { handleCatsForOnlyCats } from '../../modules/productListing/_handleCatsForOnlyCats';
import { facetRemoveAllLink, facetRemoveLink } from '../../modules/productListing/_facetRemove';

import { doResultListUpdate, doCherryResultListUpdate } from '../../modules/productListing/_doResultListUpdate';
import { ajaxAddToWishlist as _ajaxAddToWishlist } from '../../modules/productDisplay/_ajaxAddToWishlist';
import { ajaxAddToRegistry as _ajaxAddToRegistry } from '../../modules/productDisplay/_registry';
import { ajaxMoveToRegistry as _ajaxMoveToRegistry } from '../../modules/productDisplay/_registry';
import { setBackToBrowsingCookie } from '../../modules/productListing/_setBackToBrowsingCookie';
import { leftNavBrandFilter } from '../../modules/productListing/_leftNavBrandFilter';
import { hideSingleFilters_desktop } from '../../modules/productListing/_hideSingleFilters';

//
// 10. Account Modules
//-----------------------------------------------------------------------------
import { toggleReturnExchange } from '../../modules/account/_toggleReturnExchange';

import { setupQuickCheckout } from '../../modules/account/_setupQuickCheckout';

import { orderHistoryList } from '../../modules/account/_orderHistoryList';

import { orderDetailActions } from '../../modules/account/_orderDetailActions';

import { smartyAddressPopulation } from '../../modules/checkout/_smartyAddressPopulation';

import { managePopover } from '../../modules/global/_managePopover';

import { updateShippingValue } from '../../modules/account/_updateShippingValue';

import { updateShippingMethods } from '../../modules/account/_updateShippingMethods';

import { moveItemToWishList } from '../../modules/global/_moveItemToWishList';
import { removeItemFromShoppingBag } from '../../modules/global/_removeItemFromShoppingBag';
import { addAllInterestItemsToBag } from '../../modules/global/_addAllInterestItemsToBag';

import { moveItemToShoppingBag } from '../../modules/global/_moveItemToShoppingBag';
import { removeItemFromWishList } from '../../modules/global/_removeItemFromWishList';
import { retrieveOrderHistory } from '../../modules/global/_retrieveOrderHistory';
import { resetForm as resetContactUsForm } from '../../modules/contactUs/_resetForm';
import { headerTippyTop, animationObserver, slickyTippy, skiptoContent, hideWhileLoading } from '../../modules/global/_headerTippyTop';
// WWW-17262 Hide Cart Timer
import { checkTimerMessage } from '../../modules/global/_checkTimerMessage';

// WWW-17718 Show New Cart Message
import { showNewCartMsg } from '../../modules/global/_showNewCartMessage';

//
// 11. Product Recs Modules
// ------------------------------------------------------
import { productRecs } from '../../modules/productRecs/_productRecs';

//
// 12. Device Specific Modules
// ------------------------------------------------------

import { registryFAQ } from '../../modules/global/_registryFAQ';

// 13. Fonts Loaded
// ------------------------------------------------------
import { fontsLoaded } from '../../modules/global/_fonts';

import { keepRegLoc } from '../../modules/registry/_manageRegistry';

//
//TO DO -> Check to see if need refactored,needed, or needs moved.
// -----------------------------------------------------------------------------

//
// Return these functions to the window scope for legacy code.
// These should be refactored in future development.
// -----------------------------------------------------------------------------

//FROM ABOVE
import { getCaptchaSecurityCode } from '../../modules/global/_getCaptchaSecurityCode';
import { updatePageNumber } from '../../modules/productListing/_updatePageNumber';
import { loadlazy } from '../../modules/global/_lazyload';
import { setMarketingCookies } from '../../modules/global/_setMarketingCookies';
import { startIntl } from '../../modules/international/_intl';
import { internationalScrollTo_FAQ } from '../../modules/international/_internationalScrollTo_FAQ';
import { buildDropdown } from '../../modules/global/_buildDropdown';
import { homepageCarouselHeightDesktop } from '../../modules/carousel/_homepageCarouselHeight';
import { bannerCarousels_dt, splashCarousel_dt } from '../../modules/carousel/_bannerCarousels';
import { responsiveGenericCarousel_dt, responsiveSplashCarousel_dt } from '../../modules/carousel/_responsiveCarousel';
import { pageSetup } from '../../modules/carousel/_pageSetup';
import { lazyLoadImage } from '../../modules/global/_lazyLoadImage';
import { loadAjaxQueue } from '../../modules/global/_ajaxQueue';
import { easyListSplitter } from '../../modules/global/_easyListSplitter';
import { outdatedBrowserCheck } from '../../modules/deviceSpecific/_browserCheck';
import { allDevicesCheckForAlert } from '../../modules/productDisplay/_checkForAlert';
import { loadDefaultImg_desktop, allDevicesProductImgMissing, allDevicesHideSingleAltImage } from '../../modules/productDisplay/_images';
import { allDevicesPanelIconToggle } from '../../modules/productDisplay/_panelIconToggle';
import { desktopTabletMoveShopperActions } from '../../modules/productDisplay/_shopperActions';
import { flatSizeClick } from '../../modules/productDisplay/_swatchClick';
import { flatSizeResize } from '../../modules/productDisplay/_swatchClick';
import { swapImgSources } from '../../modules/productListing/_swapImgSources';
import { addCheckboxesToDomForFacets } from '../../modules/productListing/_addCheckboxesToDomForFacets';
import { checkForSavedState } from '../../modules/productListing/_checkForSavedState';
import { recoverFacetsFromURL } from '../../modules/productListing/_recoverFacetsFromURL';
import { myDillardsBar } from '../../modules/layout/_myDillardsBar';
import { sortFourProductBanners } from '../../modules/productListing/_sortFourProductBanners';
import { desktopToggleFacets } from '../../modules/productListing/_toggleFacets';
import { facetBinds } from '../../modules/productListing/_facetBinds';
import { allDevicesColorSelectBox } from '../../modules/productDisplay/_shopperActions';
import { setSelected } from '../../modules/productDisplay/_shopperActions';
import { allDevicesSwatchClick } from '../../modules/productDisplay/_swatchClick';
import { oneColorSwatchSelect } from '../../modules/productDisplay/_swatchClick';
import { outOfStockTooltip } from '../../modules/productDisplay/_outOfStockTooltip';
import { slickSwatches_productpage } from '../../modules/productDisplay/_slickSwatches';
import { featuredBrands } from '../../modules/registry/_carousel';
import { resultImgMissing } from '../../modules/productListing/_resultImgMissing';
import { hideFooterEmailSignup } from '../../modules/global/_hideFooterEmailSignup';

var $body = $('body'),
	$html = $('html');

function deviceClass() {
	$html.addClass('desktopPage').removeClass('touch');
	return 'desktopPage';
}

function isTouch() {
	return false;
}

function pageType() {
	return $body.attr('id');
}

Dillards.getDdsUUID = getDdsUUID;
Dillards.getFeatureFlagVariation = getFeatureFlagVariation;
createOptiUser();

Dillards.config = {
	deviceClass: deviceClass(),
	touch: isTouch(),
	pageType: pageType(),
};
Dillards.checkShipInternational = checkShipInternational;
Dillards.getCookie = getCookie;
Dillards.setExpiringCookieOrWebStorage = setExpiringCookieOrWebStorage;
Dillards.getCookieOrWebStorage = getCookieOrWebStorage;
Dillards.setCookieOrWebStorage = setCookieOrWebStorage;
Dillards.removeCookieOrWebStorage = removeCookieOrWebStorage;
Dillards.getCaptchaSecurityCode = getCaptchaSecurityCode;
Dillards.doScrollToTop = everythingScrolls.doScrollToTop;
Dillards.formValidation = formValidation;
Dillards.updatePageNumber = updatePageNumber;
Dillards.orderHistoryList = orderHistoryList;
Dillards.smartyAddressPopulation = smartyAddressPopulation;

//shopping bag
if (Dillards.config.pageType === 'layoutCart') {
	setupPaypalExpressCheckout();
	setupApplePayCartPage();
}

// Set subdomain path for static assets
switch (window.location.host) {
	case 'www':
		Dillards.sub = '//www.dillards.com';
		break;
	case 'idevstgmig':
		Dillards.sub = '//istdevstg1.dillards.com';
		break;
	case 'idevmig':
		Dillards.sub = '//istdev1.dillards.com';
		break;
	case 'iqastgmig':
		Dillards.sub = '//istqastg1.dillards.com';
		break;
	case 'iqamig':
		Dillards.sub = '//istqa1.dillards.com';
		break;
	case 'iperf':
		Dillards.sub = '//istperf1.dillards.com';
		break;
	case 'istgmig':
		Dillards.sub = '//iststg1.dillards.com';
		break;
	case 'localhost':
		Dillards.sub = '//localhost';
		break;
	default:
		//Prod subdomain
		Dillards.sub = '//www.dillards.com';
}

//for use later
loadlazy();

buildDropdown();
// carousel folder
if ($('#layoutHomepage').length > 0) {
	homepageCarouselHeightDesktop();
	splashCarousel_dt();
	responsiveSplashCarousel_dt();
}
pageSetup();
bannerCarousels_dt();
//responsiveGenericCarousel_dt();
lazyLoadImage();

// global folder
loadAjaxQueue();
easyListSplitter();
outdatedBrowserCheck();
//slickStatic();
setAuthHeaders();

// productDisplay folder
if (Dillards.config.pageType === 'layoutProduct') {
	allDevicesColorSelectBox();
	setSelected();
	allDevicesSwatchClick();
	oneColorSwatchSelect();
	outOfStockTooltip();
}
allDevicesCheckForAlert();
allDevicesHideSingleAltImage();
loadDefaultImg_desktop();
allDevicesPanelIconToggle();
allDevicesProductImgMissing();
desktopTabletMoveShopperActions();
flatSizeClick();
flatSizeResize();

// productListing folder
swapImgSources();
addCheckboxesToDomForFacets();
if (Dillards.config.pageType === 'layoutCategory' || Dillards.config.pageType === 'layoutSearch') {
	desktopToggleFacets();
	facetBinds();
}
checkForSavedState();
recoverFacetsFromURL(true);
myDillardsBar();
sortFourProductBanners();
if ($('#registryLayout').length > 0) {
	featuredBrands();
	resultImgMissing();
}
if ($('#layoutStandard').length > 0) {
	hideFooterEmailSignup();
}
if ($('#layoutProduct').length > 0) {
	slickSwatches_productpage();
}
permTippyTop();
$(window).trigger('abovefoldfinished');
Dillards.abovefoldfinished = true;
//END FROM ABOVE

window.ACMZ1_zp = productRecs.ACMZ1_zp;
window.ARMZ1_zp = productRecs.ARMZ1_zp;
window.JFYZ1_zp = productRecs.JFYZ1_zp;
window.PDPZ1_zp = productRecs.PDPZ1_zp;
window.PDPZ2_zp = productRecs.PDPZ2_zp;
window.PDPZ3_zp = productRecs.PDPZ3_zp;
window.SCPZ1_zp = productRecs.SCPZ1_zp;
window.SRPZ1_zp = productRecs.SRPZ1_zp;
window.recentlyViewed = productRecs.recentlyViewed;

if (typeof Dillards !== 'undefined') {
	Dillards.resetContactUsForm = resetContactUsForm;
	Dillards.retrieveOrderHistory = retrieveOrderHistory;
	Dillards.removeItemFromWishList = removeItemFromWishList;
	Dillards.moveItemToShoppingBag = moveItemToShoppingBag;
	Dillards.addAllInterestItemsToBag = addAllInterestItemsToBag;
	Dillards.removeItemFromShoppingBag = removeItemFromShoppingBag;
	Dillards.moveItemToWishList = moveItemToWishList;
	Dillards.swapMyDillardsButtons = swapMyDillardsButtons;
	Dillards.setCookies = setCookies;
	Dillards.setExpiringCookies = setExpiringCookies;
	Dillards.setAkamaiWait = setAkamaiWait;
	Dillards.populateStates = populateStates;
	Dillards.storeCityChange = storeCityChange;
	Dillards.getUrlVar = getUrlVar;
	Dillards.facetRemoveAllLink = facetRemoveAllLink;
	Dillards.facetRemoveLink = facetRemoveLink;
	Dillards.doResultListUpdate = doResultListUpdate;
	Dillards.updateShippingValue = updateShippingValue;
	Dillards.updateShippingMethods = updateShippingMethods;
	Dillards.scene7 = {
		img_ecom308x357: '$ecom308x357$',
		img_ecom88x102: '$ecom88x102$',
		img_ecomchanel110x110: '$ecomchanel110x110$',
		img_ecom396x459: '$ecom396x459$',
		img_ecom264x306: '$ecom264x306$',
		img_ecom150x173: '$ecom150x173$',
		img_ecom1760x2040: '$ecom1760x2040$',
		img_ecomchanel200x200: '$ecomchanel200x200$',
		img_ecom880x1020: '$ecom880x1020$',
		img_ecom132x153: '$ecom132x153$',
	};
	Dillards.ajaxShareProduct = _ajaxShareProduct;
	Dillards.getPageViewData = _getPageViewData;
	Dillards.ajaxAddToWishlist = _ajaxAddToWishlist;
	Dillards.ajaxMoveToRegistry = _ajaxMoveToRegistry;	

	Dillards.matchElementHeight = matchElementHeight;
	Dillards.getNumberFromCookie = _getNumberFromCookie;
	Dillards.submitForm = submitForm;
	Dillards.Validate = Validate;
	Dillards.inventoryOnHandEmail = inventoryOnHandEmail;
	dillardsModal();
	Dillards.triggerModal = dillardsModal.triggerModal;
	Dillards.selectOnChangePersonalization = selectOnChangePersonalization;

	//checkout section
	Dillards.estimateShippingAndTax = estimateShippingAndTax;
	Dillards.skipGift = skipGift;
	Dillards.submitModalCart = submitModalCart;
	Dillards.popupPrint = eGiftcardFunctions.popupPrint;
	Dillards.submitEmailSignupForm = submitEmailSignupForm;
	Dillards.ajaxEmailSignup = ajaxEmailSignup;
	Dillards.ajaxTextSignup = ajaxTextSignup;
	Dillards.submitTextSignupForm = submitTextSignupForm;
	Dillards.promptEmailOptInModal = promptEmailOptInModal;
	Dillards.getURLParamValue = getURLParamValue;
	Dillards.sanitizeInputAgainstXSS = sanitizeInputAgainstXSS;
	Dillards.promoRewardModalBinds = promoRewardModalBinds;
	Dillards.getCardBrand2 = getCardBrand2;
	Dillards.callRecs = callRecs;
	Dillards.savePersonalizationPointsToDatabase = savePersonalizationPointsToDatabase;
}

//
//Run these modules on document ready.
// -----------------------------------------------------------------------------
$(function () {
	$(window).trigger('belowfoldfinished');
	Dillards.belowFoldFinished = true;
	// carousel folder
	allDevicesResetAltImgContainer();
	desktopTabletVerticalRecs();
	carouselResize();

	// global folder
	addPageClass();
	desktopTabletLoadAdaptiveImg();
	checkCookie();
	checkForSpecialCharactersInUrl();
	checkForResultListForContentRecWidget();
	everythingScrolls.scrollIt();
	everythingScrolls.scrollUp();
	everythingScrolls.windowLogoScroll();
	showBackToRegistryLink();
	callAjaxEspots();
	buttonGroupActiveFix();
	breadCrumbs();
	formValidation();
	stripRestrictedCharFromInput();
	inlineFormValidationOnBlur();
	toggleShopBrands();
	captchaWhatsThisToggle();
	selectScroller();
	getUrlVars();
	submitFormKeyCodes();
	preventDoubleClick();
	wlSetGridState();
	customCheckBox();
	triggerUpdateWriteReviewFields();
	viewProductPersonalizationTracking();
	orderCompletePersonalizationTracking();
	managePopover();
	doCherryResultListUpdate();
	removeOldDotDillardsCookies();
	fixedOutfitImg();
	fixedOutfitImgScroll();
	cvvSecurityCodeToggle();
	valToLowercase();
	expireObsoleteCookies();
	qtyEnter();
	passwordFailTip();
	adaEventBinds();
	qtyButtons();
	headerTippyTop();
	slickyTippy();
	hideWhileLoading();
	window.forceHeaderRender = slickyTippy;
	skiptoContent();
	animationObserver();
	// WWW-17262 Hide Cart Timer
	checkTimerMessage();

	if (Dillards.config.pageType === 'layoutProduct') {
		// productDisplay folder
		allDevicesAltImageClickSetup();
		allDevicesCaptureCachedState();
		allDevicesCheckShipInternationalOnLoad();
		allDevicesColorRegistryButton();
		getCYL();
		initCollections();
		allDevicesProductImage();
		allDevicesProductPageSetup();
		allDevicesWanelo();
		zoomMainImageD();
		powerReviews_all();
		powerReviews_dt();
		wishListResponse();
		eGiftcardFunctions.eGiftcard();
		scrollToATWLAlert();
	}

	if (Dillards.config.pageType === 'layoutCategory' || Dillards.config.pageType === 'layoutSearch') {
		//	productListing folder
		hideSingleFilters_desktop();
		handleCatsForOnlyCats();
		setBackToBrowsingCookie();
		leftNavBrandFilter();
	}

	// account folder
	if (Dillards.config.pageType === 'layoutMember') {
		wishlist();
		setupQuickCheckout();
		orderHistoryList(); 
		orderDetailActions();
		toggleReturnExchange();
		memberClickBind();
		showPassword();
		confirmShowPassword();
		personalInfoPagePassword();
		smartyAddressPopulation();
	}
	myFavoritesInit();
	personalizationInit();

	if (Dillards.config.pageType === 'layoutMember' || Dillards.config.pageType === 'layoutCheckout') {
		loginInputFocus();
		updateRewardCodeCount();
		compareCaptchaLogin();
	}

	//check out folder
	dropdownChanges();

	//shopping bag
	if (Dillards.config.pageType === 'layoutCart') {
		allDevicesChanelOverMaxReached();
		allDevicesDeclineGift();
		allDevicesIsInternationalRegistry();
		allDevicesPressEnterToEstTax();
		allDevicesToggleEstTax();
		allDevicesSetupCheckoutPages();
		// WWW-17718 Show New Cart Message
		showNewCartMsg();
	}

	// checkout folder
	if (Dillards.config.pageType === 'layoutCheckout') {
		allDevicesCheckRegisterCheckbox();
		allDevicesClearPasswordField();
		desktopTabletChangePanelUI();
		allDevicesSetupCheckoutPages();
		estTaxPopup();
		setupPaypalPaymentPage();
		setupAfterpay();
		orderCompleteCreateAccount();
		smartyAddressPopulation();
	}

	//contact us
	if (Dillards.config.pageType === 'layoutStandard') {
		documentSet();
	}

	if (Dillards.config.pageType === 'layoutContent') {
		registryFAQ();
		allDevicesBindEventTypeToRURL();
		internationalScrollTo_FAQ();
	}

	if (Dillards.config.pageType === 'layoutCart') {
		itsatrapmodal();
		tap2zoom_shoppingbag();
		tap2zoom_wl();
		updateQty();
	}

	if (Dillards.config.pageType === 'layoutRegistry') {
		keepRegLoc();
		smartyAddressPopulation();
	}

	//global
	fontsLoaded();
	retrieveIntlCacheCallVariable();
	// remove oo preloader
	if ($('#oo_tab_right_preload').length) {
		$('#oo_tab_right_preload').remove();
	}

	promptEmailOptInModal();

	if (Cookies.get('zCountry') != 'US') {
		startIntl();
	}
});
